export const buttonStyles = {
    infoButton: {
        color: "status.info",
    },
    editButton: {
        "&:hover, &:focus": {
            color: "status.info",
        },
    },
    deleteButton: {
        "&:hover, &:focus": {
            color: "status.danger",
        },
    },
    tableHeadRow: {
        "&:first-of-type": {
            backgroundColor: "#000000",
            color: "#000000",
        },
    },
    finishButton: {
        background: 'status.success',
        color: 'white.main',
    }
};

export const TableContainerStyle = {
    "& .MuiTablePagination-toolbar": {
        paddingLeft: ["1rem", "1rem", "1rem", "1rem", "1rem", "1rem"],
        height: ["2rem", "2rem", "2.15rem", "2.15rem", "3rem", "3rem"],
        fontSize: [
            "0.6rem", "0.6rem", "0.6rem", "0.6rem", "0.875rem", "0.875rem",
        ],
        minHeight: ["2.15rem", "2.15rem", "2.15rem", "2.15rem", "3.25rem", "3.25rem",
        ],
    },
    "& .MuiTablePagination-selectLabel": {
        fontSize: ["0.6rem", "0.6rem", "0.6rem", "0.6rem", "0.875rem", "0.875rem",
        ],
    },
    "& .MuiTablePagination-select": {
        paddingLeft: ["0.25rem", "0.25rem", "0.25rem", "0.25rem", "0.75rem", "0.75rem",
        ],
        paddingRight: ["0.2rem", "0.25rem", ".75rem !important",
            "1.15rem !important", "2rem !important", "2rem !important",
        ],
        maxWidth: "80px",
    },
    "& .MuiTablePagination-displayedRows": {
        fontSize: ["0.6rem", "0.6rem", "0.6rem", "0.6rem", "0.875rem", "0.875rem",
        ],
        minWidth: ["fit-content", "fit-content", "fit-content", "6rem", "7rem", "7rem",],
        maxWidth: ["fit-content", "fit-content", "fit-content", "6rem", "7rem", "7rem",]
    },
    "& .MuiInputBase-root": {
        marginRight: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", ".75rem", ".75rem",
        ],
        marginLeft: ["0.25rem", "0.25rem", "0.25rem", "0.25rem", ".75rem", ".75rem",
        ],
    },
    "& .MuiSvgIcon-root": {
        fontSize: ["1.15rem", "1.15rem", "1.15rem", "1.15rem", "2rem", "2rem",
        ],
    },
    "& .MuiTablePagination-actions": {
        marginLeft: ["0.25rem", "0.25rem", "0.25rem !important",
            "0.8rem !important", "1.2rem !important", "1.2rem !important",
        ],
    },
    "& .MuiIconButton-root": {
        padding: ["0.33rem", "0.33rem", "0.33rem", ".33rem", ".5rem", ".5rem",
        ],
    },
    "& .MuiIconButton": {
        fontSize: ["1.5rem", "1.5rem", "1.15rem", "1.15rem", "1.5rem", "1.5rem",
        ],
    },
    "& .MuiTablePagination-spacer": {
        flex: ""
    },
    width: "100%",
    display: 'flex',
    justifyContent: 'flex-start',
}

export const CircularProgressStyles =
{
    padding: [
        "0.5rem",
        "0.5rem",
        "0.33rem",
        ".33rem",
        ".5rem",
        ".5rem",
    ],
    fontSize: [
        "1.5rem",
        "1.5rem",
        "1.15rem",
        "1.15em",
        "1.5rem",
        "1.5rem",
    ],
    cx: 20,
    cy: 20,
    width: [
        "30px !important",
        "30px !important",
        "30px !important",
        "30px !important",
        "40px !important",
        "40px !important",
    ],
    height: [
        "30px !important",
        "30px !important",
        "30px !important",
        "30px !important",
        "40px !important",
        "40px !important",
    ],
}

export const TableHeadStyle = {
    "& .MuiTableRow-head": {
        fontSize: "parent",
        padding: { xs: "0.5rem", lg: "1rem" },
    },
    "& .MuiTableCell-root": {
        padding: { xs: "0.5rem", lg: "1rem" },
    },
    "& .MuiTableSortLabel-icon": {
        fontSize: { xs: "0.75rem", lg: "1.125rem" },
    },
}

export const TableStyle = {
    "& .MuiTableCell-root": {
        fontSize: [
            "0.6rem",
            "0.6rem",
            "0.6rem",
            "0.6rem",
            "0.875rem",
            "0.875rem",
        ],
        padding: [
            "0.66rem",
            "0.66rem",
            "0.66rem",
            "0.66rem",
            "0.75rem",
            "0.75rem",
        ],
    },
    "& .MuiTableCell-paddingNone": {
        padding: "0 !important",
    },

}